import { styled } from "@mui/material/styles";
import { color, fontWeight } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";

export const MyDataTable = styled(DataGrid)({
  "& .MuiDataGrid-row--borderBottom": {
    background: "rgba(238, 242, 255, 0.7)!important",
    borderBottom: "1px solid rgb(152 162 179 / var(--tw-border-opacity, 1))",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: "700",
  },
  "& .MuiButtonBase-root": {
    /// background: "#000",
    color: "#000",
  },
  // "& .MuiDataGrid-cell": {
  //   overflow: "inherit",
  // },
  // "& .MuiDataGrid-main": {
  //   overflow: "visible",
  // },

  // "& .MuiDataGrid-cell": {
  //   overflow: "inherit",
  // },
  // .sticky-cell
});
